export class GrauEscolaridade {
  idGrauEscolaridade: number = null;
  dsGrauEscolaridade: string = null;

  constructor(d?) {
    if (d) {
      this.idGrauEscolaridade = d.idGrauEscolaridade ? d.idGrauEscolaridade : null;
      this.dsGrauEscolaridade = d.dsGrauEscolaridade ? d.dsGrauEscolaridade : null;
    }
  }
}
